<template>
	<div class="bonus-card-item">
		<div class="first-line"></div>
		<div class="sec-line"></div>
		<div class="third-line"></div>
		<div class="forth-line"></div>
		<div class="fifth-line"></div>
		<div class="six-line"></div>
	</div>
</template>
<script>
	export default{
		name: 'bonusCar',
	}
</script>
<style lang="less" scoped="">
	.bonus-card-item {
		position: relative;
		margin-top: 20px;
		padding: 30px 20px;
		display: inline-block;
		height: 216px;
		width: 280px;
		font-size: 0;
		cursor: pointer;
		overflow: hidden;
		background-color: #fff;

		&:not(:nth-child(4n+1)) {
			margin-left: 20px;
		}
		div {
			background-color: #f5f7fa;
		}
		.first-line {
			height: 16px;
		}
		.sec-line {
			margin-top: 8px;
			width: 120px;
			height: 16px;
		}
		.third-line {
			margin-top: 16px;
			height: 12px;
		}
		.forth-line {
			margin-top: 6px;
			height: 12px;
		}
		.fifth-line {
			margin-top: 6px;
			width: 120px;
			height: 12px;
		}
		.six-line {
			position: absolute;
			left: 20px;
			bottom: 30px;
			width: 120px;
			height: 20px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/bonusCard.vue